"use client"

import { Switch } from "@/components/ui/switch"
import { Label } from "@/components/ui/label"
import { Dispatch, SetStateAction } from "react"

interface ImportOptionsProps {
  options: {
    overwrite: boolean
    storeOnArweave: boolean
  }
  setOptions: Dispatch<
    SetStateAction<{ overwrite: boolean; storeOnArweave: boolean }>
  >
}

export function ImportOptions({ options, setOptions }: ImportOptionsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-base font-medium">Import options</h3>

        <div className="flex items-center space-x-2">
          <Switch
            id="overwrite"
            checked={options.overwrite}
            onCheckedChange={(checked) =>
              setOptions((prev) => ({ ...prev, overwrite: checked }))
            }
          />
          <Label htmlFor="overwrite" className="text-sm cursor-pointer">
            Overwrite existing posts with the same slugs
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Switch
            id="arweave"
            checked={options.storeOnArweave}
            onCheckedChange={(checked) =>
              setOptions((prev) => ({ ...prev, storeOnArweave: checked }))
            }
          />
          <Label htmlFor="arweave" className="text-sm cursor-pointer">
            Store imported posts on Arweave (permanent storage)
          </Label>
        </div>
      </div>
    </div>
  )
}
